// Utility functions for handling delivery address overrides stored in localStorage

// Key used for localStorage
const STORAGE_KEY = 'delivery-address-overrides';

// Get all saved overrides
export const getAddressOverrides = () => {
    try {
        const savedData = localStorage.getItem(STORAGE_KEY);
        if (!savedData) return {};
        return JSON.parse(savedData);
    } catch (error) {
        console.error('Error loading delivery address overrides:', error);
        return {};
    }
};

// Get override for a specific document
export const getAddressOverride = (docNo) => {
    const overrides = getAddressOverrides();
    return overrides[docNo] || null;
};

// Save an override for a document
export const saveAddressOverride = (docNo, data) => {
    try {
        const overrides = getAddressOverrides();
        overrides[docNo] = {
            ...data,
            timestamp: new Date().toISOString()
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
        return true;
    } catch (error) {
        console.error('Error saving delivery address override:', error);
        return false;
    }
};

// Remove an override for a document
export const removeAddressOverride = (docNo) => {
    try {
        const overrides = getAddressOverrides();
        if (overrides[docNo]) {
            delete overrides[docNo];
            localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
        }
        return true;
    } catch (error) {
        console.error('Error removing delivery address override:', error);
        return false;
    }
};

// Clear all overrides
export const clearAllAddressOverrides = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
        return true;
    } catch (error) {
        console.error('Error clearing all delivery address overrides:', error);
        return false;
    }
};